// extracted by mini-css-extract-plugin
module.exports = {"attendeeItemHolder":"AttendeeItem_attendeeItemHolder__3O61p","attendeeItemHolderSelected":"AttendeeItem_attendeeItemHolderSelected__rJVzn"};